import { differenceInDays } from 'date-fns';

export const expiredDays = (expiredDate: Date) => {
  const daysDifferential = differenceInDays(new Date(), expiredDate);

  if (daysDifferential <= 0) {
    return {
      isFuture: true,
      days: Math.abs(daysDifferential),
    };
  } else {
    return {
      isFuture: false,
      days: daysDifferential,
    };
  }
};
